<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem to="/system/dictiona"> <Icon type="icon iconfont icon-bianma" /> pro管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="md-add-circle" /> 编辑pro </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <div class="titlable">
          <span>新增pro</span>
        </div>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
          <FormItem prop="gkPro_mn">
            <Input v-model="formValidate.gkPro_mn" class="inptext" size="large" placeholder="请输入编码" />
          </FormItem>
          <FormItem v-for="(item, index) in formValueList" :key="index">
            <div class="formsty">
              <div class="spantext">{{ item.keys }}</div>
              <Input v-model.trim="item.values" type="number" class="inptext" size="large" placeholder="请输入标准值" />
              <div>
                <!-- <Button v-if="formValueList.length > 1" type="error" class="btnsty" @click="delValue(index)">删除</Button> -->
                <!-- <Button v-if="formValueList.length-1 == index" type="info" class="btnsty" @click="addValue">添加</Button> -->
              </div>
            </div>
          </FormItem>

          <FormItem>
            <Button @click="backmast">返回</Button>
            <Button type="primary" style="margin-left: 32px" @click="handleSubmit('formValidate')">提交</Button>
          </FormItem>
        </Form>
      </Card>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 表单验证数据
      formValidate: {
        gkPro_mn: '', // 编码
      },
      formValueList: [], // 标准值数据
      oldNumber: '', // 未修改之前的编号
      types: '工况',

      ruleValidate: {
        // 定义数据验证
        gkPro_mn: [
          {
            required: true,
            message: '编码不能为空!',
            trigger: 'blur',
          },
        ],
      },
      proId: '', // 标准值id
    };
  },
  mounted() {
    this.proId = this.$route.query.proid;
    this.getProInfo();
  },
  methods: {
    // 通过id获取信息
    getProInfo() {
      const api = this.ApiUrl + 'gkPro/findValues';
      const data = {
        PRONumber: this.proId,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            if (res.data.extend.pageInfo.length > 0) {
              this.formValueList = res.data.extend.pageInfo;
              this.formValidate.gkPro_mn = this.formValueList[0].pronumber;
              this.oldNumber = this.formValueList[0].pronumber;
            }
          } else {
            this.$Message.error('添加失败!');
          }
        },
        res => {},
      );
    },
    /**
     * 验证表单提交事件
     */
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 运行提交方法
          this.addCodeInfo();
        } else {
          this.$Message.error('失败!');
        }
      });
    },
    /**
     * 新增编码
     */
    addCodeInfo() {
      const api = this.ApiUrl + 'gkPro/updatePro';
      // 获取所有标准值
      let valueList = '';

      let valFlag = true;
      this.formValueList.forEach(ele => {
        if (ele.values !== '') {
          valueList += `${ele.keys}:${ele.values},`;
        } else {
          valFlag = false;
        }
      });
      if (!valFlag) {
        this.$Message.error('标准值不能为空');
        return;
      }
      valueList = valueList.substring(0, valueList.length - 1);

      const data = {
        values: valueList,
        NewPRONumber: this.formValidate.gkPro_mn,
        OldPRONumber: this.oldNumber,
      };
      this.$http.post(api, JSON.stringify(data)).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('修改成功');

            // 返回编码页
            setTimeout(() => {
              this.$router.push({
                path: '/proinfo/prolist',
              });
            }, 1800);
          } else {
            this.$Message.error('添加失败!');
          }
        },
        res => {},
      );
    },

    // 返回编码页
    backmast() {
      this.$router.push({
        path: '/proinfo/prolist',
      });
    },
    /**
     * 增加一个框
     */
    addValue() {
      this.formValueList.push({
        value: '',
      });
    },
    /**
     * 删除一个框
     */
    delValue(num) {
      this.formValueList.splice(num, 1);
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.picbox {
  height: 12.5rem;
  width: 12.5rem;
  border: 1px solid #ccc;
}

.titlable {
  height: 24px;
  border-left: 0.125rem solid #17233d;
  padding-left: 20px;
  line-height: 24px;
  margin-bottom: 20px;
}

.cominfo {
  display: flex;
  flex-direction: column;
}

.inptext {
  width: 25rem;
}

.inpuarea {
  margin-top: 0.625rem;
  width: 25rem;
}

.btnbox {
  margin-top: 1.25rem;
  width: 25rem;
  display: flex;
}

.btnbox > button {
  margin-right: 200px;
}

.spantext {
  font-size: 20px;
  font-weight: bold;
  margin-right: 10px;
}

.formsty {
  display: flex;
  align-items: center;
}

.btnsty {
  margin-left: 10px;
}
</style>
